import { format } from "date-fns";
import moment from "moment";

export function getDate(d: Date) {
    return `${d.getDate()}/${d.getMonth()}/${d.getFullYear()}`;
}

export function stringToDate(_date, _format, _delimiter) {
    if (!_date) return
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
}
export function convertToDateObject(dateString?: string) {
    if (!dateString) {
        return null
    }
   const newString =  dateString.replace(/\//g, '-')
    const [year, month, day] = newString?.split('-');
    if (!year || !month || !day) {
        return null
    }
    const dateObject = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

    return dateObject;
}

export function getMonthBetweenDates(inicio: Date, fim: Date) {
    const meses = [];
    let dataInicial = new Date(inicio);
    let dataFinal = new Date(fim);
    dataInicial.setDate(1);
    let dataAtual = new Date(dataInicial);
    dataFinal.setDate(1);
    dataFinal.setHours(23);
    dataFinal.setMinutes(59);
    dataFinal.setSeconds(59);
    while (dataAtual <= dataFinal) {
        const mes = dataAtual.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' });
        meses.push(mes);
        dataAtual.setMonth(dataAtual.getMonth() + 1);
    }
    return meses;
}

export const getMaxDate = (incidentDate:string) => {
    const parts = incidentDate?.split('/');
    if (!parts?.length) {
        return new Date()
    }
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is zero-indexed in JavaScript Date objects
    const year = parseInt(parts[2], 10);
    
    const date = new Date(year, month, day);
    
    return date
}

export function formatDateTime(date: Date) {
    const formattedDate = format(date, 'dd/MM/yyyy - HH\'h\'mm');
    return formattedDate 
}

export function dateStringFormat(stringDate: string, format: string) {
    return moment(stringDate).format(format)
}

export function formatNotificationDate(dateString: string): string {
    if (!dateString) return 'Não informado'
    
    try {
        // Parse the date string and format to dd/mm/yyyy - hh:mm
        const date = new Date(dateString)
        if (isNaN(date.getTime())) {
            return 'Data inválida'
        }
        return format(date, 'dd/MM/yyyy - HH:mm')
    } catch (error) {
        console.error('Erro ao formatar data:', error)
        return 'Data inválida'
    }
}